<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<p style="text-align: center;margin-top:180pt;font-weight:bold;">‘ We are the Pilgrims, master; we shall go</p>
<p style="text-align: center;font-weight:bold;">Always a little further; it may be</p>
<p style="text-align: center;font-weight:bold;">Beyond that last blue mountain barred with snow</p>
<p style="text-align: center;font-weight:bold;">Across that angry or that glimmering sea…’</p><br/>
<p style="text-align: right;">– Inscription on the clock tower at Stirling Lines</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0003.vue?95647f04